"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useResizeObserver = useResizeObserver;

var _useIsomorphicLayoutEffect = _interopRequireDefault(require("../utils/useIsomorphicLayoutEffect"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useResizeObserver(callback) {
  (0, _useIsomorphicLayoutEffect.default)(() => {
    const observer = new window.ResizeObserver(() => callback());
    observer.observe(document.documentElement);
    return () => {
      observer.disconnect();
    };
  }, [callback]);
}